<template>
  <footer>
    <!-- Desktop Footer -->
    <div
      id="desktop-footer"
      class="bg-footer h-18 sm:h-28 mb-24 sm:mb-0 text-center py-2 sm:py-4 px-5 text-footerLink"
    >
      <template v-if="bldgStore.property?.isActive">
        <router-link
          :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}`"
          class="hover:text-blue-500"
        >
          Home
        </router-link>
        |
        <span v-if="isLoggedIn">
          <router-link
            :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/account`"
            class="hover:text-blue-500"
          >
            Account
          </router-link>
          |
          <a class="cursor-pointer hover:text-blue-500" @click="logout"> Logout </a>
        </span>
        <router-link
          v-else
          :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/login`"
          class="hover:text-blue-500"
        >
          Login
        </router-link>
        |
        <span v-if="enableBuildingSwitcher">
          <a
            @click="emit('openBuildingSwitcher')"
            class="cursor-pointer hover:text-blue-500"
          >
            Switch Building
          </a>
          |
        </span>
        <span v-if="isLoggedIn && isAdmin">
          <router-link
            :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/admin`"
            class="hover:text-blue-500"
          >
            Admin
          </router-link>
          |
        </span>
        <router-link
          :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/terms`"
          class="hover:text-blue-500"
        >
          Terms <span class="hidden sm:inline">of use</span>
        </router-link>
        |
        <router-link
          :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/privacy`"
          class="hover:text-blue-500"
        >
          Privacy <span class="hidden sm:inline">Policy</span>
        </router-link>
      </template>

      <div class="text-lightblack">
        <span class="hidden font-serif italic"> Powered by AK Productions </span>
        <span class="text-sm">
          &copy; {{ new Date().getFullYear() }} AK Productions, LLC
        </span>
        <span class="text-gray-900 text-sm font-mono px-2 py-1 ml-2 bg-slate-300">
          v{{ version }}
        </span>
        <span v-if="isLoggedIn && bldgStore.property?.isAlertEnabled && (bldgStore.property as any)?.isPushNotificationsEnabled">
          <button
            v-if="notificationsEnabled"
            class="ml-4 text-sm text-blue-500 hover:bg-blue-900 hover:text-white"
            @click="onDisableNotifications?.()"
          >
            <span class="text-sm py-2">
              <span class="font-bold">Notifications Active</span>
            </span>
          </button>
          <button
            v-else
            class="ml-4 text-sm text-blue-500 hover:bg-blue-900 hover:text-white"
            @click="onEnableNotifications?.()"
          >
            <span class="text-sm py-2">
              <span class="font-bold">Enable Notifications</span></span
            >
          </button>
        </span>
      </div>

      <!-- <div
        v-if="isLoggedIn"
        class="text-footerLinkTiny text-gray-400 font-mono"
      >
        {{ userAgent }}
      </div> -->
    </div>

    <!-- Mobile Footer -->
    <div
      id="mobile-footer"
      v-if="bldgStore.property"
      class="sm:hidden py-4 flex fixed bottom-0 w-full justify-center text-footerLinkTiny border-t-2 bg-white"
    >
      <router-link
        :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}`"
        :class="enableBuildingSwitcher ? 'pl-5 pr-11' : 'px-5'"
      >
        <div class="ml-1 mb-1"><img src="\images\home.png" alt="" /></div>
        <div>HOME</div>
      </router-link>
      <router-link
        v-if="isLoggedIn"
        :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/account`"
        class="px-5"
      >
        <div class="ml-[1em] mb-1"><i-heroicons-outline-user class="h-6 w-6" /></div>
        <div>ACCOUNT</div>
      </router-link>
      <router-link
        v-else
        :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/login`"
        class="px-5"
      >
        <div class="ml-0.5 mb-1"><i-heroicons-outline-user class="h-6 w-6" /></div>
        <div>LOGIN</div>
      </router-link>
      <a
        v-if="enableBuildingSwitcher"
        class="px-5 cursor-pointer"
        @click="emit('openBuildingSwitcher')"
      >
        <div class="ml-[2.9em] mb-1">
          <i-heroicons-outline-office-building class="h-6 w-6" />
        </div>
        <div>SWITCH BUILDING</div>
      </a>
      <router-link
        v-if="isLoggedIn && isAdmin"
        :to="isPropertyLoading ? '' : `/${bldgStore.siteCode}/admin`"
        class="px-5"
      >
        <div class="ml-1 mb-1">
          <i-heroicons-outline-user class="h-6 w-6" />
        </div>
        <div>ADMIN</div>
      </router-link>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";

import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "../store/userStore";


var bldgStore = useBldgStore();
var userStore = useUserStore();
var router = useRouter();
var isPropertyLoading = computed(() => bldgStore.isLoading);
var isLoggedIn = computed(() => userStore.isLoggedIn);
var isAdmin = computed(() => userStore.isAdmin);




defineProps<{
  enableBuildingSwitcher?: boolean;
  notificationsEnabled?: boolean;
  onEnableNotifications?: () => void;
  onDisableNotifications?: () => void;
}>();
const emit = defineEmits<{ (e: "openBuildingSwitcher"): void }>();
const version = import.meta.env.VITE_SAFETYNET_VERSION;

async function logout() {
  await userStore.logoff();
  // Clears the shared token for every API client, including userClient - which
  // the old per-store list missed, leaving userStore.authToken truthy after logout.
  userStore.setAuthToken("");

  console.log("User successfully logged out");
  router.push("/" + bldgStore.siteCode);
}
</script>
